import script from "./phoneInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./phoneInput.vue?vue&type=script&lang=ts&setup=true"

import "./phoneInput.vue?vue&type=style&index=0&id=0ce1ecba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce1ecba"]])

export default __exports__